import { create } from 'zustand';

interface EngageFilterState {
  /** Pipe-separated appTypes from the selected AppMetaGroup (null = "All") */
  appTypeFilter: string | null;
  tags: string[];
  searchText: string;
  searchScope: 'all' | 'folder';
  /** Favorites-only tab: when true the list shows only the user's favorited engage items/folders. */
  favoritesOnly: boolean;

  setAppTypeFilter: (filter: string | null) => void;
  setTags: (tags: string[]) => void;
  setSearchText: (text: string) => void;
  setSearchScope: (scope: 'all' | 'folder') => void;
  setFavoritesOnly: (favoritesOnly: boolean) => void;
  clearFilters: () => void;
  hasActiveFilters: () => boolean;
}

export const useEngageFilterStore = create<EngageFilterState>((set, get) => ({
  appTypeFilter: null,
  tags: [],
  searchText: '',
  searchScope: 'all',
  favoritesOnly: false,

  setAppTypeFilter: (appTypeFilter) => set({ appTypeFilter }),
  setTags: (tags) => set({ tags }),
  setSearchText: (text) => {
    if (get().searchText !== text) set({ searchText: text });
  },
  setSearchScope: (scope) => {
    if (get().searchScope !== scope) set({ searchScope: scope });
  },
  setFavoritesOnly: (favoritesOnly) => set({ favoritesOnly }),
  clearFilters: () =>
    set({
      appTypeFilter: null,
      tags: [],
      searchText: '',
      favoritesOnly: false,
    }),
  hasActiveFilters: () => {
    const s = get();
    return s.appTypeFilter !== null || s.tags.length > 0 || s.searchText.length > 0;
  },
}));
